import { Theme } from '@mui/material/styles'

const muiSlider = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        height: 2
      },
      rail: {
        background: theme.colors.stroke
      },
      valueLabel: {
        background: theme.palette.text.primary,
        color: theme.palette.primary.contrastText,
        fontSize: '0.75rem',
        borderRadius: 8,
        padding: '0.5rem'
      },
      markLabel: {
        top: 40
      },
      thumb: {
        '&.Mui-focusVisible': {
          boxShadow: 'none'
        },
        '&::before': {
          boxShadow: 'none'
        },
        '&.Mui-active': {
          boxShadow: 'none',
          '&::after': {
            // background: theme.palette.success.light,
            zIndex: -1
          }
        }
      }
    }
  }
}

export default muiSlider
